import { Component, OnDestroy, OnInit } from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    selector: 'property-summary-page',
    templateUrl: './property-summary-page.component.html',
    styleUrls: ['./property-summary-page.component.scss']
})
export class ResidentialForSalePropertySummaryPageComponent
    extends PropertyPageBase
    implements OnInit, OnDestroy {
    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertySummary, draftFacade, routerFacade);
    }

    // TODO: a better way to handle per field formatting on the summary page.
    // to get rid of a lot of non required code for each fields formatting etc

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
